import { authClient, API } from '../index'

// Get all technologies
export const getAllActiveTechnologies = () => {
    return authClient().get(`${API}/technology/`)
}

export const getAllTechnologies = () => {
    return authClient().get(`${API}/technology/?getDisabled=true`)
}

// Get technology by id
export const getTechnologyById = (id) => {
    return authClient().get(`${API}/technology/${id}`)
}

// Create technology
export const postTechnology = async (technology) => {
    return authClient().post(`${API}/technology/`, technology)
}

// Update text
export const updateTechnology = (id, technology) => {
    return authClient().put(`${API}/technology/${id}`, technology)
}

// Change status technology
export const changeStatusTechnology = async (id, active) => {
    return authClient().put(`${API}/technology/change-status/${id}`, { active });
};


// Delete technology
export const deleteTechnology = (id) => {
    return authClient().delete(`${API}/technology/${id}`)
}

